import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from 'localize-router';
import { BsDropdownModule, PaginationModule } from 'ngx-bootstrap';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { DisplayModule } from '../display/display.module';
import { TemplateDirective } from './base/template.directive';
import { DatatableColumnComponent } from './datatable.column.component';
import { DatatableComponent } from './datatable.component';
import { DatatableFooterComponent } from './footer/datatable-footer.component';
import { DatatableHeaderComponent } from './header/datatable-header.component';

@NgModule({
  declarations: [
    DatatableComponent,
    DatatableColumnComponent,
    DatatableHeaderComponent,
    DatatableFooterComponent,
    TemplateDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    LocalizeRouterModule,
    PaginationModule.forRoot(),
    BsDropdownModule.forRoot(),
    NgxUiLoaderModule,
    DisplayModule
  ],
  exports: [
    PaginationModule,
    DatatableComponent,
    DatatableColumnComponent,
    // Directive
    TemplateDirective
  ]
})
export class DatatableModule {
}
